import { render, staticRenderFns } from "./PublisherDetail.vue?vue&type=template&id=9073e4f2&"
import script from "./PublisherDetail.vue?vue&type=script&lang=js&"
export * from "./PublisherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports